import React from 'react';

export const Cluster = ({ cluster }) => {

  const style = {
    border: 'solid 2px darkgrey',
    borderRadius: '8px',
    backgroundColor: 'white',
    padding: '1em',
    textAlign: 'center'
  };

  return cluster.length == 1
  ? <div style={style}>no cluster</div>
  : <div style={style}>cluster</div>
}